import React from 'react';
import { FileText, Zap, Users, ShieldCheck, Lock, CreditCard, Globe } from 'lucide-react';
import { Button } from './Shared';
export const Hero = () => {
  return <section className="relative px-4 overflow-hidden py-6 md:py-10" data-id="element-153">
      {/* Decorative stars */}
      <div className="absolute top-10 left-10 w-2 h-2 bg-gold-400 rounded-full opacity-50 blur-[1px]" data-id="element-154"></div>
      <div className="absolute top-20 right-20 w-3 h-3 bg-gold-400 rounded-full opacity-30 blur-[2px]" data-id="element-155"></div>

      <div className="max-w-6xl mx-auto text-center" data-id="element-156">
        <div className="inline-flex items-center space-x-2 text-gold-400 font-serif font-semibold tracking-wider uppercase text-[10px] md:text-xs mb-3" data-id="element-157">
          <span className="w-6 md:w-8 h-[1px] bg-gold-400" data-id="element-158"></span>
          <Globe className="w-3 h-3 md:w-4 md:h-4" data-id="element-159" />
          <span data-id="element-160">MUNDO PRÁCTICO™</span>
          <span className="w-6 md:w-8 h-[1px] bg-gold-400" data-id="element-161"></span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-2 leading-[1.1] break-words" data-id="element-162">
          Todo lo que necesitás para manejar <br className="hidden md:block" data-id="element-163" />
          los berrinches de tu hijo.
        </h1>
        <p className="text-base md:text-2xl font-serif italic text-gold-400 mb-4 md:mb-6" data-id="element-164">
          Listo. Desde hoy.
        </p>

        <div className="relative max-w-xl mx-auto px-4 mt-2 mb-3 md:mt-4 md:mb-4" data-id="element-165">
          <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(234,179,8,0.15)_0%,transparent_70%)] rounded-full" data-id="element-166"></div>
          <picture data-id="element-167">
            <source type="image/webp" srcSet="https://cdn.magicpatterns.com/uploads/j9syN6FEsaq2NV9pEVTge3/MockUp-Calma-Total_(1)_(1).webp?w=400 400w, https://cdn.magicpatterns.com/uploads/j9syN6FEsaq2NV9pEVTge3/MockUp-Calma-Total_(1)_(1).webp?w=800 800w, https://cdn.magicpatterns.com/uploads/j9syN6FEsaq2NV9pEVTge3/MockUp-Calma-Total_(1)_(1).webp 1080w" sizes="(max-width: 768px) 80vw, 500px" data-id="element-168" />
            <img src="https://cdn.magicpatterns.com/uploads/j9syN6FEsaq2NV9pEVTge3/MockUp-Calma-Total_(1)_(1).webp" srcSet="https://cdn.magicpatterns.com/uploads/j9syN6FEsaq2NV9pEVTge3/MockUp-Calma-Total_(1)_(1).webp?w=400 400w, https://cdn.magicpatterns.com/uploads/j9syN6FEsaq2NV9pEVTge3/MockUp-Calma-Total_(1)_(1).webp?w=800 800w, https://cdn.magicpatterns.com/uploads/j9syN6FEsaq2NV9pEVTge3/MockUp-Calma-Total_(1)_(1).webp 1080w" sizes="(max-width: 768px) 80vw, 500px" alt="MegaPack Calma Total" className="relative z-10 w-full max-w-[280px] md:max-w-full mx-auto h-auto drop-shadow-2xl" width={1080} height={1080} loading="eager" fetchPriority="high" decoding="sync" data-id="element-169" />
          </picture>
        </div>

        <p className="text-gray-200 mt-3 mb-2 text-xs md:text-[13px]" data-id="element-170">
          El sistema N°1 de crianza práctica para familias argentinas — Niños de
          1 a 7 años
        </p>
        <p className="text-gray-100 max-w-2xl mx-auto mt-2 mb-4 text-[11px] md:text-[12px] leading-tight md:leading-normal" data-id="element-171">
          Protocolos + herramientas + frases exactas listos para usar. Sin
          improvisar. Sin explotar. Sin culpa del domingo a la noche.
        </p>

        <div className="flex flex-wrap justify-center gap-y-2 gap-x-3 md:gap-8 text-gray-100 px-2 mt-4 mb-5" data-id="element-172">
          <div className="flex items-center text-[10px] md:text-sm whitespace-nowrap shrink-0" data-id="element-173">
            <FileText className="w-3 h-3 md:w-4 md:h-4 mr-1 text-gold-400" data-id="element-174" />{' '}
            100% PDF
          </div>
          <div className="flex items-center text-[10px] md:text-sm whitespace-nowrap shrink-0" data-id="element-175">
            <Zap className="w-3 h-3 md:w-4 md:h-4 mr-1 text-gold-400" data-id="element-176" /> Acceso
            en 5 min
          </div>
          <div className="flex items-center text-[10px] md:text-sm whitespace-nowrap shrink-0" data-id="element-177">
            <Users className="w-3 h-3 md:w-4 md:h-4 mr-1 text-gold-400" data-id="element-178" /> Niños
            1 a 7 años
          </div>
          <div className="flex items-center text-[10px] md:text-sm whitespace-nowrap shrink-0" data-id="element-179">
            <ShieldCheck className="w-3 h-3 md:w-4 md:h-4 mr-1 text-gold-400" data-id="element-180" />{' '}
            Garantía 7 días
          </div>
        </div>

        <Button href="#plan-premium" className="mb-4 w-full md:w-auto text-sm md:text-xl px-4 md:px-10 py-3.5 md:py-5" data-id="element-181">
          🟠 → QUIERO MI MEGAPACK CALMA TOTAL AHORA
        </Button>
        <div className="flex items-center justify-center space-x-3 text-xs md:text-sm text-gray-300 mb-4 md:mb-8" data-id="element-182">
          <span className="flex items-center" data-id="element-183">
            <Lock className="w-3 h-3 md:w-4 md:h-4 mr-1" data-id="element-184" /> Pago seguro
          </span>
          <span className="text-gray-600" data-id="element-185">|</span>
          <span className="flex items-center" data-id="element-186">
            <CreditCard className="w-3 h-3 md:w-4 md:h-4 mr-1" data-id="element-187" /> Mercado Pago
          </span>
        </div>
      </div>
    </section>;
};